import { LockKeyhole, User } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { ROUTES } from "@/constants"
import logo from "/images/Full Logotype.svg"
import { useXsrfToken } from "@/components/hooks/useXsrfToken"
import Flash from "@/components/ui/flash"
import { useTranslation } from "react-i18next"
import { buttonVariants } from "@/components/ui/button-variants"
import { Link } from "@/lib/page-rendering"

export default function New() {
  const { t } = useTranslation("users", { keyPrefix: "form.sign_in" })
  return (
    <Card className="m-8 max-w-md min-w-96 self-center p-8">
      <CardContent>
        <div className="mb-8 flex flex-row items-center justify-center">
          <img src={logo} alt="Sagecool Logo" className="h-[90px]" />
        </div>
        <form
          className="flex flex-col gap-8"
          action={ROUTES.LOGIN}
          method="post"
        >
          <Flash />
          <input
            type="hidden"
            name="authenticity_token"
            value={useXsrfToken()}
          />
          <div className="focus-within:ring-ring flex flex-row items-center rounded-md focus-within:ring-2 focus-within:ring-offset-2">
            <div className="border-input flex h-10 flex-row items-center rounded-md rounded-r-none border border-r-0 pl-2">
              <User className="text-gray-300" strokeWidth={1} />
            </div>
            <Input
              placeholder={t("email")}
              required
              name="user[email]"
              className="focus:border-input! grow rounded-l-none border-l-0 focus:ring-0!"
            />
          </div>
          <div className="focus-within:ring-ring flex flex-row items-center rounded-md focus-within:ring-2 focus-within:ring-offset-2">
            <div className="border-input flex h-10 flex-row items-center rounded-md rounded-r-none border border-r-0 pl-2">
              <LockKeyhole className="text-gray-300" strokeWidth={1} />
            </div>
            <Input
              placeholder={t("password")}
              type="password"
              name="user[password]"
              required
              className="focus:border-input! grow rounded-l-none border-l-0 focus:ring-0!"
            />
          </div>

          <Button type="submit" className="w-full">
            Log in
          </Button>
        </form>
        <Link
          href={"/users/password/new"}
          className={buttonVariants({
            variant: "link",
            className: "pt-6 pl-0",
          })}
        >
          {t("forgot_password")}
        </Link>
      </CardContent>
    </Card>
  )
}
